import { render, staticRenderFns } from "./preTable.vue?vue&type=template&id=2412a68f&scoped=true&"
import script from "./preTable.vue?vue&type=script&lang=js&"
export * from "./preTable.vue?vue&type=script&lang=js&"
import style0 from "./preTable.vue?vue&type=style&index=0&id=2412a68f&prod&lang=scss&"
import style1 from "./preTable.vue?vue&type=style&index=1&id=2412a68f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2412a68f",
  null
  
)

export default component.exports